"use client";

import { AppRouterErrorFallback } from "cy-fe/src/error-handling";
import {
  type NextjsAppRouterError,
  useReportNextjsError,
} from "cy-datadog/client";

export default function Error({
  error,
  reset,
}: {
  error: NextjsAppRouterError;
  reset: () => void;
}) {
  useReportNextjsError(error);

  return <AppRouterErrorFallback reset={reset} />;
}
